import {
  Button,
  makeStyles,
  Grid,
  Checkbox,
  FormControl,
  OutlinedInput,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import {
  adminPermissionRoles,
  columnTypesList,
  created_by,
} from "../../../shared-resources/dumpData";
import ColorPicker from "../../../common-components/ColorPicker";
import CustomSelect from "../../../common-components/CustomSelect";
import CustomTextField from "../../../common-components/CustomTextField";
import ActionMessages from "../../../common-components/ActionMessages";
import { checkColumnDuplicate } from "../../../shared-resources/utils";

const useStyles = makeStyles((theme) => ({
  componentStyles: {
    marginTop: "30px",
  },
  headerBox: {
    padding: "0 20px",
    minHeight: "60px",
  },
  headerBoxSecondary: {
    minHeight: "60px",
  },
  header: {
    background: "#4B5558",
    color: "#fff",
    boxShadow: "0px 1px 6px #00000029",
  },
  secondaryColumn: {
    height: "30px",
    width: "100%",
  },
  secondaryColumnSecondary: {
    height: "30px",
    width: "33.3%",
  },
  tablePaper: {
    borderRadius: "12px",
    marginTop: "20px",
  },
  dataItemRow: {
    minHeight: "30px",
    fontSize: "13px",
  },
  expandMoreIcon: {
    fontSize: "16px",
  },
  dataBoxPickList: {
    minHeight: "30px",
  },
  editIconSpan: {
    cursor: "pointer",
    marginLeft: "2px",
  },
  editIcon: {
    fontSize: "14px",
    color: "#ccc",
    cursor: "pointer",
  },
  checkCircleIcon: {
    fontSize: "18px",
    color: "#075e07",
    cursor: "pointer",
  },

  checkCircleIconSpan: {
    cursor: "pointer",
    marginLeft: "2px",
  },
  editControl: {
    height: "20px",
    fontSize: "12px",
  },
  editControlField: {
    height: "20px",
    fontSize: "12px",
  },
  addColumnBtn: {
    fontSize: "13px",
    fontWeight: "600",
    padding: "4px 12px !important",
    textTransform: "none",
    border: "1px solid #3599d1",
    borderRadius: "15px",
    color: "#3599d1",
    backgroundColor: "#fff !important",
    marginTop: "12px",
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  addDialog: {
    width: "350px",
    height: "auto",
    position: "relative",
  },

  cancelBtn: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
  saveBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    border: "1px solid #3599d1",
    color: "#ffff",
    backgroundColor: "#0176d3",
    marginRight: "8px",
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    fontSize: "13px",
  },
  hasRangeLabel: {
    fontWeight: 600,
    fontSize: "13px",
  },
  required: {
    color: "red",
  },
  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
}));

export default function ProjectManagementFields({
  projectManagementPermissions,
  projectManagementPermissionsSecondary,
  changePrimaryTable,
  changeSecondaryable,
}) {
  const classes = useStyles();

  const [primaryTableData, setPrimaryTableData] = useState([]);
  const [secondaryTableData, setSecondaryTableData] = useState([]);
  const [openDialogAdd, setOpenDialogAdd] = useState(false);
  const [columnName, setColumnName] = useState("");
  const [columnType, setColumnType] = useState("Text");
  const [isRange, setIsRange] = useState(false);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [isColumnClick, setIsColumnClick] = useState(false);

  useEffect(() => {
    const primData = JSON.parse(JSON.stringify(projectManagementPermissions));
    const secData = JSON.parse(
      JSON.stringify(projectManagementPermissionsSecondary)
    );
    primData.forEach((item) => {
      item.adminPicklistSettingsList.forEach(
        (item1) => (item1.isEditable = false)
      );
    });
    setPrimaryTableData(primData);
    setSecondaryTableData(secData);
  }, [projectManagementPermissions, projectManagementPermissionsSecondary]);

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onChangeEnabled = (i, item, type) => {
    if (type === "primary") {
      const dataChange = JSON.parse(JSON.stringify(primaryTableData));
      dataChange[i][item] = !dataChange[i][item];
      dataChange[i].modified_by = created_by;
      dataChange[i].modified_date = new Date();
      setPrimaryTableData(dataChange);
      changePrimaryTable(dataChange);
    } else {
      const dataChange = JSON.parse(JSON.stringify(secondaryTableData));
      dataChange[i][item] = !dataChange[i][item];
      dataChange[i].modified_by = created_by;
      dataChange[i].modified_date = new Date();
      setSecondaryTableData(dataChange);
      changeSecondaryable(dataChange);
    }
  };

  const onChange = (i, item, e, type) => {
    if (type === "primary") {
      const dataChange = JSON.parse(JSON.stringify(primaryTableData));
      dataChange[i][item] = e.target.value;
      dataChange[i].modified_by = created_by;
      dataChange[i].modified_date = new Date();
      setPrimaryTableData(dataChange);
      changePrimaryTable(dataChange);
    } else {
      const dataChange = JSON.parse(JSON.stringify(secondaryTableData));
      dataChange[i][item] = e.target.value;
      dataChange[i].modified_by = created_by;
      dataChange[i].modified_date = new Date();
      setSecondaryTableData(dataChange);
      changeSecondaryable(dataChange);
    }
  };

  const onChangeEnabledPickList = (i, j) => {
    const dataChange = JSON.parse(JSON.stringify(primaryTableData));
    dataChange[i].adminPicklistSettingsList[j].is_enabled =
      !dataChange[i].adminPicklistSettingsList[j].is_enabled;
    dataChange[i].adminPicklistSettingsList[j].modified_by = created_by;
    dataChange[i].adminPicklistSettingsList[j].modified_date = new Date();
    dataChange[i].modified_by = created_by;
    dataChange[i].modified_date = new Date();
    setPrimaryTableData(dataChange);
    changePrimaryTable(dataChange);
  };

  const changeEditStatus = (i, j) => {
    const dataChange = JSON.parse(JSON.stringify(primaryTableData));
    dataChange[i].adminPicklistSettingsList[j].isEditable =
      !dataChange[i].adminPicklistSettingsList[j].isEditable;
    setPrimaryTableData(dataChange);
  };

  const changeColor = (val, index, i, j) => {
    const dataChange = JSON.parse(JSON.stringify(primaryTableData));
    dataChange[i].adminPicklistSettingsList[j].color = val;
    dataChange[i].adminPicklistSettingsList[j].modified_by = created_by;
    dataChange[i].modified_by = created_by;
    dataChange[i].modified_date = new Date();
    dataChange[i].adminPicklistSettingsList[j].modified_date = new Date();
    setPrimaryTableData(dataChange);
    changePrimaryTable(dataChange);
  };

  const optionChange = (e, i, j) => {
    const dataChange = JSON.parse(JSON.stringify(primaryTableData));
    dataChange[i].adminPicklistSettingsList[j].name = e.target.value;
    dataChange[i].adminPicklistSettingsList[j].modified_by = created_by;
    dataChange[i].modified_by = created_by;
    dataChange[i].modified_date = new Date();
    dataChange[i].adminPicklistSettingsList[j].modified_date = new Date();
    setPrimaryTableData(dataChange);
    changePrimaryTable(dataChange);
  };

  const addMoreClick = (i) => {
    const dataChange = JSON.parse(JSON.stringify(primaryTableData));
    dataChange[i].adminPicklistSettingsList.push({
      name: "",
      color: "#000000",
      isEditable: true,
      is_enabled: true,
      created_by: created_by,
      created_date: new Date(),
      modified_by: created_by,
      modified_date: new Date(),
    });
    setPrimaryTableData(dataChange);
    changePrimaryTable(dataChange);
  };

  const handleCloseDialogAdd = () => {
    setOpenDialogAdd(false);
  };

  const onAddClick = () => {
    setColumnName("");
    setIsColumnClick(false);
    setColumnType("");
    setIsRange(false);
    setOpenDialogAdd(true);
  };

  const onChangeColumnName = (e) => {
    setColumnName(e.target.value);
  };

  const onChangeColumnType = (e) => {
    setColumnType(e.target.value);
  };

  const onCancelClick = () => {
    setOpenDialogAdd(false);
  };

  const onAddColumnClick = () => {
    setIsColumnClick(true);
    const dataChange = JSON.parse(JSON.stringify(primaryTableData));
    if (columnName.trim() === "" || columnType.trim() === "") {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText("Please fill required fields");
      return;
    }
    if (checkColumnDuplicate(dataChange, columnName, "fields")) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`${columnName} field already exists`);
      return;
    }
    dataChange.push({
      fields: columnName,
      field_type: columnType,
      isrange: isRange,
      isaddmore: true,
      ispriority: false,
      adminPicklistSettingsList: [],
      isenabledvisible: true,
      isenabledfreeze: false,
      is_enabled: true,
      isvisibilityddl: true,
      visibility: ["Admin"],
      iseditaccessddl: true,
      edit_access: ["Admin"],
      isprojectdetailsvisible: true,
      isprojectdetailsfreeze: false,
      proj_details_view: true,
      isprojectanalysisvisible: true,
      isprojectanalysisfreeze: false,
      proj_analysis_view: true,
      isprojectcreationvisible: true,
      isprojectcreationfreeze: false,
      proj_creation_view: true,
      setting_type: 3,
      created_by: created_by,
      modified_by: created_by,
      modified_date: new Date(),
      created_date: new Date(),
    });
    setPrimaryTableData(dataChange);
    changePrimaryTable(dataChange);
    setOpenDialogAdd(false);
  };

  return (
    <div className={classes.componentStyles}>
      <table className="settingsTable" cellSpacing={0}>
        <thead>
          <tr>
            <td style={{ width: "40%" }} rowSpan={2}>
              Fields
            </td>
            <td style={{ width: "10%" }} rowSpan={2}>
              Enabled
            </td>
            <td style={{ width: "50%" }} colSpan={3}>
              View
            </td>
          </tr>
          <tr>
            <td style={{ width: "16%" }}>Project Details</td>
            <td style={{ width: "16%" }}>Project Analytics</td>
            <td style={{ width: "16%" }}>Project Creation</td>
          </tr>
        </thead>
        <tbody>
          {primaryTableData.map((item, i) => (
            <>
              <tr>
                <td>
                  <span style={{ float: "left" }}>{item.fields}</span>
                  {(item.field_type === "Picklist" ||
                    item.field_type === "Picklist-Multiselect") &&
                    item.setting_type !== 4 && (
                      <span style={{ float: "left", margin: "2px 0 0 6px" }}>
                        <ExpandMoreIcon className={classes.expandMoreIcon} />
                      </span>
                    )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {item.isenabledvisible && (
                    <Checkbox
                      className="customCheckBox"
                      checked={item.is_enabled}
                      color="primary"
                      disabled={item.isenabledfreeze}
                      onClick={() =>
                        onChangeEnabled(i, "is_enabled", "primary")
                      }
                    />
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {item.isprojectdetailsvisible && (
                    <Checkbox
                      className="customCheckBox"
                      checked={item.proj_details_view}
                      color="primary"
                      disabled={item.isprojectdetailsfreeze}
                      onClick={() =>
                        onChangeEnabled(i, "proj_details_view", "primary")
                      }
                    />
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {item.isprojectanalysisvisible && (
                    <Checkbox
                      className="customCheckBox"
                      checked={item.proj_analysis_view}
                      color="primary"
                      disabled={item.isprojectanalysisfreeze}
                      onClick={() =>
                        onChangeEnabled(i, "proj_analysis_view", "primary")
                      }
                    />
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {item.isprojectcreationvisible && (
                    <Checkbox
                      className="customCheckBox"
                      checked={item.proj_creation_view}
                      color="primary"
                      disabled={item.isprojectcreationfreeze}
                      onClick={() =>
                        onChangeEnabled(i, "proj_creation_view", "primary")
                      }
                    />
                  )}
                </td>
              </tr>
              {(item.field_type === "Picklist" ||
                item.field_type === "Picklist-Multiselect") &&
                item.setting_type !== 4 && (
                  <tr>
                    <td
                      style={{
                        width: "40%",
                        padding: 0,
                        borderBottom: "none !important",
                      }}
                    >
                      <table className="picklistTable" cellSpacing={0}>
                        <thead>
                          <tr>
                            <td
                              style={{
                                borderRight: "1px solid #ebebeb",
                                borderBottom: "1px solid #ebebeb",
                                width: "40%",
                              }}
                            >
                              Picklist Values
                            </td>

                            <td
                              style={{
                                borderRight: "1px solid #ebebeb",
                                borderBottom: "1px solid #ebebeb !important",
                                width: "8%",
                              }}
                            >
                              Colors
                            </td>
                            <td
                              style={{
                                border: "none !important",
                                width: "6%",
                              }}
                            />
                            <td
                              style={{
                                borderBottom: "none !important",
                                borderRight: "none !important",
                                width: "8%",
                              }}
                            />
                          </tr>
                        </thead>
                        <tbody>
                          {item.adminPicklistSettingsList.map((val, j) => (
                            <>
                              <tr>
                                <td
                                  style={{
                                    borderRight: "1px solid #ebebeb",
                                    borderBottom: "1px solid #ebebeb",
                                  }}
                                >
                                  {val.isEditable ? (
                                    <FormControl
                                      variant="outlined"
                                      className={classes.editControl}
                                    >
                                      <OutlinedInput
                                        className={classes.editControlField}
                                        type="text"
                                        onChange={(e) => optionChange(e, i, j)}
                                        value={val.name}
                                      />
                                    </FormControl>
                                  ) : (
                                    val.name
                                  )}
                                </td>

                                <td
                                  style={{
                                    borderRight: "1px solid #ebebeb",
                                    borderBottom: "1px solid #ebebeb",
                                  }}
                                >
                                  <ColorPicker
                                    changeColor={(val, index) =>
                                      changeColor(val, index, i, j)
                                    }
                                    inputColor={val.color}
                                  />
                                </td>
                                <td
                                  style={{
                                    borderBottom: "none !important",
                                    borderRight: "none !important",
                                  }}
                                >
                                  {val.isEditable ? (
                                    <span
                                      className={classes.checkCircleIconSpan}
                                    >
                                      <CheckCircleIcon
                                        className={classes.checkCircleIcon}
                                        onClick={() => changeEditStatus(i, j)}
                                      />
                                    </span>
                                  ) : (
                                    <span className={classes.editIconSpan}>
                                      <EditIcon
                                        className={classes.editIcon}
                                        onClick={() => changeEditStatus(i, j)}
                                      />
                                    </span>
                                  )}
                                </td>
                                <td
                                  style={{
                                    textAlign: "left",
                                    borderBottom: "none !important",
                                    borderRight: "none !important",
                                  }}
                                >
                                  <Checkbox
                                    className="customCheckBox"
                                    checked={val.is_enabled}
                                    color="primary"
                                    onClick={() =>
                                      onChangeEnabledPickList(i, j)
                                    }
                                  />
                                </td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </td>
                    <td colSpan={4} />
                  </tr>
                )}
              {item.isaddmore &&
                (item.field_type === "Picklist" ||
                  item.field_type === "Picklist-Multiselect") &&
                item.setting_type !== 4 && (
                  <tr>
                    <td colSpan={5}>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => addMoreClick(i)}
                      >
                        Add More +
                      </span>
                    </td>
                  </tr>
                )}
            </>
          ))}
        </tbody>
      </table>
      <Button
        className={classes.addColumnBtn}
        variant="contained"
        onClick={onAddClick}
      >
        Add Column
      </Button>
      {secondaryTableData.length > 0 && (
        <table
          style={{ marginTop: "20px" }}
          className="settingsTable"
          cellSpacing={0}
        >
          <thead>
            <tr>
              <td style={{ width: "40%" }} rowSpan={2}>
                Field
              </td>
              <td style={{ width: "10%" }} rowSpan={2}>
                Enabled
              </td>
              <td style={{ width: "50%" }} colSpan={3}>
                View
              </td>
            </tr>
            <tr>
              <td style={{ width: "16%" }}>Project Details</td>
              <td style={{ width: "16%" }}>Project Analytics</td>
              <td style={{ width: "16%" }}>Project Creation</td>
            </tr>
          </thead>
          <tbody>
            {secondaryTableData.map((item, i) => (
              <tr>
                <td style={{ width: "40%" }}>{item.fields}</td>
                <td style={{ width: "10%", textAlign: "center" }}>
                  {item.isenabledvisible && (
                    <Checkbox
                      className="customCheckBox"
                      checked={item.is_enabled}
                      color="primary"
                      disabled={item.isenabledfreeze}
                      onClick={() =>
                        onChangeEnabled(i, "is_enabled", "secondary")
                      }
                    />
                  )}
                </td>
                <td style={{ width: "16%", textAlign: "center" }}>
                  {item.isprojectdetailsvisible && (
                    <Checkbox
                      className="customCheckBox"
                      checked={item.proj_details_view}
                      color="primary"
                      disabled={item.isprojectdetailsfreeze}
                      onClick={() =>
                        onChangeEnabled(i, "proj_details_view", "secondary")
                      }
                    />
                  )}
                </td>
                <td style={{ width: "16%", textAlign: "center" }}>
                  {item.isprojectanalysisvisible && (
                    <Checkbox
                      className="customCheckBox"
                      checked={item.proj_analysis_view}
                      color="primary"
                      disabled={item.isprojectanalysisfreeze}
                      onClick={() =>
                        onChangeEnabled(i, "proj_analysis_view", "secondary")
                      }
                    />
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {item.isprojectcreationvisible && (
                    <Checkbox
                      className="customCheckBox"
                      checked={item.proj_creation_view}
                      color="primary"
                      disabled={item.isprojectcreationfreeze}
                      onClick={() =>
                        onChangeEnabled(i, "proj_creation_view", "secondary")
                      }
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <Dialog
        open={openDialogAdd}
        onClose={handleCloseDialogAdd}
        aria-labelledby="max-width-dialog-title"
        // disableBackdropClick
      >
        <DialogContent className={classes.addDialog}>
          <div className={classes.popupHeader}>
            <span
              className={classes.closeIconAdd}
              onClick={() => setOpenDialogAdd(false)}
            >
              x
            </span>
            <div className={classes.addColumnTitle}>Add Column</div>
          </div>
          <Grid container spacing={2}>
            <Grid item lg={12}>
              <div className={classes.fieldTitle}>
                Column Name<span className={classes.required}>*</span>
              </div>
              <CustomTextField
                selectedValue={columnName}
                onChangeItem={onChangeColumnName}
                labelVal="Column Name"
                id="columnName"
                errorValue={columnName.trim() === "" && isColumnClick}
              />
            </Grid>
            <Grid item lg={12}>
              <div className={classes.fieldTitle}>
                Column Type<span className={classes.required}>*</span>
              </div>
              <CustomSelect
                selectedValue={columnType}
                onChangeItem={onChangeColumnType}
                labelVal="Column Type"
                id="columnType"
                items={columnTypesList}
                errorValue={columnType.trim() === "" && isColumnClick}
              />
            </Grid>
            {/*{columnType === "Picklist" && (
              <Grid item lg={12}>
                <span className={classes.hasRangeLabel}>Has Range?</span>
                <Checkbox
                  className="customCheckBox"
                  checked={isRange}
                  color="primary"
                  onClick={() => setIsRange(!isRange)}
                />
              </Grid>
            )}*/}
          </Grid>
          <div className={classes.popupBtnsAdd}>
            <Button
              className={classes.saveBtn}
              variant="contained"
              color="primary"
              onClick={onAddColumnClick}
            >
              Add
            </Button>
            <Button
              variant="outlined"
              className={classes.cancelBtn}
              color="primary"
              onClick={onCancelClick}
            >
              Cancel
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
    </div>
  );
}
